
(function() {
  const EXPIRY_DAYS = 90;

  function getParameterByName(name) {
    const url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  function isFresh(timestamp) {
    const now = Date.now();
    const ageInMs = now - parseInt(timestamp || 0, 10);
    return ageInMs < EXPIRY_DAYS * 24 * 60 * 60 * 1000;
  }

  const fbclidFromUrl = getParameterByName('fbclid');
  const savedFbclid = localStorage.getItem('fbclid');
  const savedTimestamp = localStorage.getItem('fbclid_timestamp');

  // If fbclid in URL or no saved value, update storage
  if (fbclidFromUrl || !isFresh(savedTimestamp)) {
    if (fbclidFromUrl) {
      localStorage.setItem('fbclid', fbclidFromUrl);
      localStorage.setItem('fbclid_timestamp', Date.now().toString());
      document.cookie = "fbclid=" + encodeURIComponent(fbclidFromUrl) + "; path=/";
    } else {
      localStorage.removeItem('fbclid');
      localStorage.removeItem('fbclid_timestamp');
      document.cookie = "fbclid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }
  }

  function appendFbclidToLinks() {
    const fbclid = localStorage.getItem('fbclid');
    const timestamp = localStorage.getItem('fbclid_timestamp');

    if (!fbclid || !isFresh(timestamp)) return;
    
    // ---- Merge our attribute with existing ones ----
    const ATTR_KEY = 'fbclid'; // or 'fbclid'
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(r => r.json())
      .then(cart => {
        const current = cart.attributes ? cart.attributes[ATTR_KEY] : undefined;
        if (current === fbclid) return;

        const merged = Object.assign({}, cart.attributes || {}, { [ATTR_KEY]: fbclid });

        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ attributes: merged })
        });
      })
      .catch(() => {});

    // keep your link appending
    document.querySelectorAll('a[href]').forEach(link => {
      const href = link.getAttribute('href');
      if (
        !href ||
        href.includes('fbclid=') ||
        href.startsWith('mailto:') ||
        href.startsWith('tel:') ||
        href.startsWith('#') ||
        (link.hostname && link.hostname !== window.location.hostname)
      ) return;

      try {
        const linkUrl = new URL(link.href, window.location.origin);
        linkUrl.searchParams.set('fbclid', fbclid);
        link.setAttribute('href', linkUrl.toString());
      } catch (e) {}
    });
  }

  document.addEventListener('DOMContentLoaded', appendFbclidToLinks);
  document.addEventListener('page:load', appendFbclidToLinks);
})();
